import * as Yup from "yup";

export const ContractSchema = Yup.object().shape({
  contractName: Yup.string().required("Campo requerido"),
  idDepartment: Yup.number().required("Campo requerido"),
  responsibilities: Yup.array()
    .min(1, "Debe agregar al menos una responsabilidad")
    .required("Campo requerido"),
});
